import SwiperCore, { Navigation } from 'swiper';
import React, {useRef, useState} from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import {GatsbyImage} from "gatsby-plugin-image";
import SliderNavButton from "./slider-nav-button";

// install Swiper modules
SwiperCore.use([Navigation]);

const MediaSlider = (
  {
    className = "",
    slides = [],
  }
) => {
  const parentRef = useRef();
  const [slideAnimationClass, setSlideAnimationClass] = useState('');
  const [currentSlideText, setCurrentSlideText] = useState('');

  return (
    <section className={`media-slider ${className}`}>
      <Swiper
        ref={parentRef}
        slidesPerView={1}
        loop={slides && slides.length > 1}
        speed={600}
        navigation={
          {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        }
        onSlideChangeTransitionStart={(swiper) => {
          const direction = swiper.activeIndex > swiper.previousIndex ? 'right' : 'left';

          setSlideAnimationClass(direction === 'right' ? 'media-slider__desktop-content-wrapper--out-left' : 'media-slider__desktop-content-wrapper--out-right');
          setTimeout(() => {
            const currentSlide = parentRef.current?.querySelectorAll('.swiper-slide')[swiper.realIndex + 1];
            const currentSlideDescWrapper = currentSlide.querySelector('.media-slider__content');

            if (currentSlideDescWrapper !== null) {
              setCurrentSlideText(currentSlideDescWrapper.innerText);
              setSlideAnimationClass(direction === 'right' ? 'media-slider__desktop-content-wrapper--in-left' : 'media-slider__desktop-content-wrapper--in-right');
            }
          }, 350);
        }}
      >
        {slides && slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="media-slider__image-wrapper">
              <GatsbyImage
                className="media-slider__image"
                image={slide.imageData}
                alt="Evo"
              />
            </div>
            {slide.description && (
              <div className="media-slider__content-wrapper">
                <p className="media-slider__content">{slide.description}</p>
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      {slides && slides.length > 1 && (
        <div className="media-slider__nav-wrapper">
          <div className="media-slider__nav-buttons-wrapper">
            <SliderNavButton
              className="media-slider__nav-button swiper-button-prev"
              direction="left"
            />
            <SliderNavButton
              className="media-slider__nav-button swiper-button-next"
              direction="right"
            />
          </div>
          <div className={`media-slider__desktop-content-wrapper ${slideAnimationClass}`}>
            <p className="media-slider__content">{currentSlideText}</p>
          </div>
        </div>
      )}
    </section>
  )
}

export default MediaSlider
